import { render, staticRenderFns } from "./StaffActive.vue?vue&type=template&id=5f676cd9&scoped=true&"
import script from "./StaffActive.vue?vue&type=script&lang=js&"
export * from "./StaffActive.vue?vue&type=script&lang=js&"
import style0 from "./StaffActive.vue?vue&type=style&index=0&id=5f676cd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f676cd9",
  null
  
)

export default component.exports